import { createStyles } from '@mantine/core';

export default createStyles((theme, { isMobile }: { isMobile: boolean }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    width: isMobile ? '100%' : '380px',
    height: 'auto',
    boxShadow: theme.shadows.md,
  },

  icon: {
    color: theme.colors.gray[6],
  },

  title: {
    fontWeight: 700,
    color: theme.colors.gray[9],
  },

  description: {
    fontWeight: 500,
    color: theme.colors.gray[7],
    textAlign: 'center',
    lineHeight: '20px',
  },

  actionsContainer: {
    marginTop: /* eslint-disable-line local-rules/use-theme-tokens */ '24px',
    width: '100%',
  },

  actionButton: {
    width: '100%',
  },
}));
